import React from 'react';
import { Church, ScanSearch, BookOpen, User } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';

const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { icon: Church, label: 'Inicio', path: '/' },
    { icon: ScanSearch, label: 'Buscar', path: '/search' },
    { icon: BookOpen, label: 'Biblioteca', path: '/library' },
    { icon: User, label: 'Perfil', path: '/profile' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-2xl z-50 safe-area-bottom">
      <div className="flex items-center justify-around px-2 py-2">
        {navItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className={`flex flex-col items-center justify-center flex-1 py-2 px-1 rounded-xl transition-all duration-300 ${
                active
                  ? 'text-[#00CCFF]'
                  : 'text-gray-500'
              }`}
            >
              <Icon size={24} strokeWidth={active ? 2.5 : 2} />
              <span className={`text-xs mt-1 font-semibold ${
                active ? 'text-[#00CCFF]' : 'text-gray-500'
              }`}>
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default BottomNav;
